import React, { FC } from "react";
import { Outlet, Terminal, dateRange } from "../../models";
import "./../OutletsTable/OutletTable.scss";
import { useTranslation } from "react-i18next";
import Link from "../../CustomComponent/Link/Link";
import useComponentVisible from "../../CustomHooks/useComponentVisible";
import FilterMenu from "../../CustomComponent/FilterMenu/FilterMenu";
import ToogleButton from "../../CustomComponent/toggleButton/toggleButton";
import ReTable from "../ReTable/ReTable";
import { DeleteIcon, OpenEyeIcon } from "../Icons/CheckOutLogo";
import { Spinner } from "react-bootstrap";

interface TerminalTableProps {
  data: {
    terminals: Terminal[] | any;
    loading: boolean;
    error: string | null;
  };
  type: string;
  subData?:
  | {
    outletDetails?: Outlet | null;
    outlets?: Outlet[] | null;
    loading: boolean;
    error: string | null;
  }
  | any;
  showArrow?: boolean;
  deleteTerminal?: any;
  setToggleConfirmScreen?: any;
  setToggleTerminalChangeStatusConfirm?: any;
  dataType?: string;
  terminalData?: any;
}

const TerminalsTable: FC<TerminalTableProps> = ({
  data,
  type,
  subData,
  deleteTerminal,
  setToggleConfirmScreen,
  setToggleTerminalChangeStatusConfirm,
  terminalData,
}) => {

  const { ref, isComponentVisible, setIsComponentVisible } =
    useComponentVisible(false);
  const { t } = useTranslation('translation', { keyPrefix: "merchantItemScreen" })


  const columns = [

    {
      label: t("tables.TSN"),
      key: "terminalSerialNumber",
      className: "grey",
    },
    { label: t("tables.deviceModel"), key: "deviceModel", className: "blue" },
    { label: t("tables.deviceId"), key: "deviceId" },
    { label: t("tables.outletName"), key: "outletName" },

    {
      label: t("tables.CreationDate"),
      key: "createdDate",
      /*  render: (data: any) => {
         const formattedDate = formatDate(data?.createdDate);
         return <span>{formattedDate}</span>;
       }, */
    },
    {
      label: t("tables.Status"),
      key: "terminalStatus",
      render: (data: any) => {
        return (
          <span className={data.terminalStatus ? "statusOK" : "statusError"}>
            {data.terminalStatus ? "Active" : "Inactive"}
          </span>
        );
      },
    },
    {
      label: t("tables.active"),
      key: "toggle",
      render: (data: any) => {
        return (
          <span>
            <ToogleButton
              isToggle={data.terminalStatus}
              handleClick={() => {
                terminalData(data);
                setToggleTerminalChangeStatusConfirm(true);
              }}
            />
          </span>
        );
      },
    },

    {
      label: "",
      key: "toggle2",
      /* className: "status", */
      render: (data: any) => {
        return (
          <span>
            <span>
              <Link to={`/terminals/${data.terminalId}`} className="down-arrow">
                <OpenEyeIcon />
              </Link>
            </span>
            {type === 'read' ? null : <span
              onClick={() => {
                deleteTerminal(data.terminalId);
                setToggleConfirmScreen(true);
              }}
            >
              <DeleteIcon />
            </span>}
          </span>
        );
      },
    },
  ];


  //     <td>{deleteTerminal ? <button className="Action-button" onClick={() => { deleteTerminal(tab.terminalId); }}> <AiOutlineDownload /> </button> : null}  </td>


  return (
    <>
      <ReTable
        data={data?.terminals}
        columns={columns}
        currentPageProp={data?.terminals?.pageable?.offset}
        page={data?.terminals?.pageable?.pageNumber}
        resultPageLength={data?.terminals?.numberOfElements}
        totalMatches={data?.terminals?.totalElements}
        totalPages={data?.terminals?.totalPages}
        loading={data.loading}
        isTableDetailRow={true}
        isPagination={false}
        showRefreshButton={false}
        showFilterButton={false}
        onFilter={() => setIsComponentVisible(true)}
        showCsvDownload={true}
        showDateFilter={false}
        error={data?.error}
      />
      <div className="filters" ref={ref}>
        {isComponentVisible ? (
          <FilterMenu
            menuTitle={t("popUps.terminalsFilter")}
            closeMenu={setIsComponentVisible}
            ApplyContent={
              data?.loading ? (
                <>
                  <Spinner
                    as="span"
                    animation="border"
                    size="sm"
                    role="status"
                    aria-hidden="true"
                  />
                </>
              ) : (
                t("popUps.apply")
              )
            }
          >
            <div className="filter-element tid_filter">
              <p className="label"> {t("tables.terminalid")}</p>
              <input
                className="input full-width"
                placeholder={t("validation.searchBy", { name: t("tables.terminalid"), keyword: t("tabs.terminals") })} 
              />
            </div>
            <div className="filter-element tsn_filter">
              <p className="label">{t("tables.TSN")} </p>
              <input className="input full-width" placeholder={t("validation.searchBy", { name: t("tables.TSN"), keyword: t("tabs.terminals") })} />
            </div>
          </FilterMenu>
        ) : null}
      </div>
    </>
  );
};

export default TerminalsTable;
